<div class="common-modal email-notification" >
    <ng-container *ngIf="EmailNotificationDetails?.length > 0">
    <div class="modal-header pop-title align-items-center" >
        <div>
            <h4 class="modal-title">
                <span>{{EmailNotificationDetails[0]?.emailType}} ({{EmailNotificationDetails[0]?.userName}})</span>
            </h4>
            <p class="d-flex mb-0 pt-1"><span *ngIf="EmailNotificationDetails[0]?.email"> Email:
                    {{EmailNotificationDetails[0]?.email}} </span>
                <span *ngIf="EmailNotificationDetails[0]?.email" class="seprator mx-2"></span> Date Sent:
                {{EmailNotificationDetails[0]?.sentOn | date :'MM/dd/yyyy hh:mm a'}}
            </p>
        </div>
        <button type="button" class="modal-close-btn close" data-dismiss="modal" (click)="close()">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                <rect width="28" height="28" rx="6" fill="none" />
                <g transform="translate(4 4)">
                    <rect width="20" height="20" fill="none" />
                    <path
                        d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z"
                        transform="translate(-0.005 0.005)" fill="#757575" />
                </g>
            </svg>
        </button>
    </div>
    <div class="modal-body modal-body-padding" style="max-height:calc(100vh - 210px); overflow: auto;" >
           
        <div class="common-table border-table">
            <table class="table">
                <thead class="">
                    <tr>
                        <th scope="col">License Number</th>
                        <th scope="col">State</th>
                        <th scope="col" style="width:250px">Class</th>
                        <th scope="col">Issue Date</th>
                        <th scope="col">Expiry Date</th>
                        <th scope="col">Expiring (In Days)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let email of EmailNotificationDetails">
                        <td>{{email.licenseNumber}}</td>
                        <td>{{email.stateCode}}</td>
                        <td>{{email.licenseClassName}}</td>
                        <td>{{email.issueDate | date :'MM/dd/yyyy'}}</td>
                        <td>{{email.expirationDate | date :'MM/dd/yyyy'}}</td>
                        <td class="text-center">{{email.expiresIn}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
        <div class="modal-footer px-4 d-flex justify-content-between align-items-center">
            <!-- <div class="button-block action-btn d-flex justify-content-between align-items-center b-4"> -->
                <img src="../../../../../../assets/images/logo-text.svg" alt="Agenzee">
                <button type="submit" class="btn btn-md primary-btn" (click)="close()">Done</button>
            <!-- </div> -->
        </div>
        </ng-container>
        <div class="modal-body modal-body-padding" style="height: 400px; overflow: auto;" [hidden]="EmailNotificationDetails?.length > 0">
        <div class="common-loader" >
            <div class="loader-icon">
                <img src="assets/images/common-loader.gif" alt="">
            </div>
        </div>
        </div>
</div>
